import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="font-display uppercase text-5xl sm:text-7xl lg:text-[8vw] leading-[0.85] text-center stroke-text">
          Neil Simon
        </div>
        <div className="mt-12 flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-white/40">
          <p>{t.footer.rights}</p>
          <div className="flex items-center gap-6">
            <span>Ward 9 · Davenport · Toronto</span>
            <Link data-testid="admin-link" to="/admin/login" className="hover:text-purple-400 transition-colors uppercase tracking-wide">
              {t.footer.admin}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
